import * as React from "react";
import { withStyles } from '@material-ui/styles';
import moment from 'moment';
import { getChainName } from '../../lib';
import Barcode from "react-barcode";
import { formatPartiallyHiddenCpf } from "../../utils/utils";
import { formatCashValue } from "../../utils/cashProduct";

const styles = () => ({
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0.5rem 0.3rem',
    fontSize: '1.4rem',
    border: '2px solid black',
    flexDirection: 'column',
    width: '10.13cm',
    backgroundColor: '#FFFFFF',
    fontFamily: 'Helvetica',
    fontWeight: 'bold',
    paddingBottom: '30px',
  },
  barcode: {
    width: '90%',
    margin: '0.6rem',
    display: 'flex',
    justifyContent: 'center',
  },
  titleContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  titleLeft: {
    textAlign: 'left',
    paddingTop: '2rem',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    marginLeft: '30px',
  },
  titleRight: {
    textAlign: 'right',
    paddingTop: '2rem',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    marginRight: '30px',
  },
  centeredMessage: {
    width: '80%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '1.2rem',
    fontSize: '1.2rem',
    textAlign: 'center',
  },
  centeredInfo: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '0.6rem',
    fontSize: '1.7rem',
  },
  dateInfo: {
    width: '80%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '0.8rem',
    fontSize: '0.9rem',
    textAlign: 'center',
  },
});

class Coupon extends React.PureComponent {
  render() {
    const { coupon, classes } = this.props;
    if (coupon) {
      const price = coupon.value;
      const place = coupon.place;
      // `issuedAt` só é passado por quem sabe que `createdAt` NÃO é o momento do resgate:
      // cupom de brinde nasce quando o cliente ganha o brinde e só recebe barcode aqui no
      // balcão, dias depois (Gift/GiftList.js). Nos demais fluxos `createdAt` é o resgate.
      // Sem nenhum dos dois (payload antigo), imprime a hora da impressão.
      const issuedAt = coupon.issuedAt || coupon.createdAt || new Date();
      const address = place ? `${place.street}, ${place.streetNumber} - ${place.city}-${place.state}` : '';

      return (
        <div className={classes.content}>
          <div className={classes.titleContainer}>
            <div className={classes.titleLeft}>PontuaX</div>
            <div className={classes.titleRight}>{getChainName()}</div>
          </div>
          <div className={classes.centeredMessage}>Produto Resgatado</div>
          {/* Produto em dinheiro também vem com isCashback = true — por isso ele é testado
              ANTES do cashback de valor livre, senão o cupom sairia impresso como "Cashback". */}
          <div className={classes.centeredInfo}>{coupon.product && coupon.product.isCash ? `Voucher no valor de ${formatCashValue(coupon.product)}` : coupon.isCashback ? `Cashback: ${Number(coupon.partnerValue).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}` : coupon.product.name}</div>
          <div className={classes.centeredInfo}>{coupon.isGift ? 'Brinde' : `${price} pontos`}</div>
          <div className={classes.barcode}>
            <Barcode value={coupon.barcode} fontSize={18} width={2} />
          </div>
          <div className={classes.centeredMessage}>Nome do Cliente: {coupon.customerName}</div>
          <div className={classes.centeredMessage}>CPF do cliente: {formatPartiallyHiddenCpf(coupon.customer)}</div>
          <div className={classes.centeredMessage}>{coupon.place? `Local de troca: ${address}` : ''}</div>
          <div className={classes.dateInfo}>Resgatado em: {moment(issuedAt).format('DD/MM/YYYY - HH:mm')}</div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default withStyles(styles)(Coupon);